/**
 * Created by mzietek on 2016-11-22.
 */

(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('RepairformsRequestService', RepairformsRequestService);

    RepairformsRequestService.$inject = ['$http', 'REST_URL'];

    function RepairformsRequestService($http, REST_URL) {
        return {
            getASCList          : getASCList,
            getCountyList       : getCountyList,
            getProductInfo      : getProductInfo,
            getTealiumTracking  : getTealiumTracking,
            getSiteIsHeadless   : getSiteIsHeadless,
            getSiteIsFootless   : getSiteIsFootless,
            getSiteIsOnMobile   : getSiteIsOnMobile,
            getHolidaysDates    : getHolidaysDates,
            sendFormData        : sendFormData,
            getCountry          : getCountry,
            getLanguage         : getLanguage,
            getDpdStores        : getDpdStores,
            getDhlStores        : getDhlStores,
            getAllCities        : getAllCities,
            getCodesForCity     : getCodesForCity,
            getBrtRemoPoints    : getBrtRemoPoints
        };

        function getAllCities() {
            return $http.post(REST_URL.SHIPMENT.NAME);
        }

        function getCodesForCity(cityId){
            return $http.post(REST_URL.SITE.SHIPMENT.CITY_ID + cityId);
        }

        function getASCList() {
            return $http.get('asc/list');
        }

        function getCountyList() {
          return $http.get('county/list');
        }

        function getProductInfo(productCode, serialNumber) {
            return $http.post(REST_URL.PRODUCT.PRODUCT_DATA, {productCode: productCode, serialNumber: serialNumber});
        }

      function getTealiumTracking() {
        return $http.get(REST_URL.SITE.HOST);
      }

      function getSiteIsHeadless() {
            return $http.post(REST_URL.SITE.IS_HEADLESS);
        }

        function getSiteIsFootless() {
            return $http.post(REST_URL.SITE.IS_FOOTLESS);
        }

        function getSiteIsOnMobile() {
            return $http.post(REST_URL.SITE.IS_MOBILE);
        }

        function getHolidaysDates() {
            return $http.post(REST_URL.CALENDAR.HOLIDAYS);
        }

        function sendFormData(requestData) {
            return $http.post(REST_URL.SUBMIT_FORM_DATA, requestData);
        }

        function getCountry() {
            return $http.post(REST_URL.SITE.COUNTRY);
        }

        function getLanguage() {
            return $http.post(REST_URL.SITE.LANGUAGE);
        }

        function getDpdStores(requestData) {
            return $http.post(REST_URL.COURIER.STORES, requestData);
        }

        function getDhlStores(requestData) {
          return $http.post(REST_URL.COURIER.STORES, requestData);
        }

        function getBrtRemoPoints(requestData) {
            return $http.post(REST_URL.COURIER.STORES, requestData);
        }
    }

})(angular);